<template>
    <div class="footer-gestion-bar d-flex align-center justify-center px-4 py-2">
        <v-icon small color="primary" class="mr-2">mdi-account-search-outline</v-icon>
        <span class="text-body-2 font-weight-bold primary--text mr-3 d-none d-sm-inline">
            Ver como
        </span>
        <ValidationObserver ref="obs" v-slot="{ invalid }" slim>
            <v-form @submit.prevent="onSubmit" class="d-flex align-center flex-grow-1">
                <ValidationProvider rules="required|numeric|max:6" v-slot="v" slim>
                    <v-text-field v-model="nroafi" outlined :min="1" :max="999999" placeholder="Nº afiliada/o"
                        single-line type="number" hide-spin-buttons dense hide-details
                        class="text-body-2 primary--text mr-2" :error-messages="v.errors[0]" @keydown="preventArrowKeys"
                        @wheel="$event.target.blur()" />
                </ValidationProvider>
                <v-btn type="submit" color="primary" elevation="0" :disabled="invalid">
                    <v-icon left>mdi-eye-outline</v-icon>
                    Cambiar
                </v-btn>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            nroafi: '',
        }
    },
    methods: {
        ...mapActions('gestion', ['entrarComoAfiliado']),
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) event.preventDefault();
        },
        onSubmit() {
            this.$refs.obs.validate().then(result => {
                if (!result) return
                // Cambio en caliente: entrarComoAfiliado pide el nuevo token
                // al back y sobrescribe sessionStorage. El iframe se remonta
                // gracias al :key="nroafiActivo" del padre, cargando el
                // portal del nuevo afiliado sin pasar por la vista busqueda.
                this.entrarComoAfiliado(parseInt(this.nroafi, 10))
                this.nroafi = ''
                this.$refs.obs.reset()
            })
        },
    },
}
</script>

<style scoped>
/* Footer del backoffice: barra blanca solida y sobria, en la misma linea
   visual que el header. Borde superior gris sutil y una sombra hacia arriba
   que la despega del panel del iframe. */
.footer-gestion-bar {
    background-color: #ffffff !important;
    border-top: 1px solid rgba(0, 0, 0, 0.10);
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
}
</style>
